import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-amber-50 to-gray-50">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-4">
          {/* Apple-themed spinner */}
          <div className="w-12 h-12 border-4 border-amber-200 border-t-amber-600 rounded-full animate-spin"></div>
        </div>
        <p className="text-amber-800 text-lg font-decorative">Loading River Styx Cider Mill...</p>
        <p className="text-amber-600 text-sm mt-1">Fresh cider since 1975</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;